import { Flex, type FlexProps, Loader } from '@inflearn/ds-react-next';

export const DefaultFallback = ({ ...props }: FlexProps) => (
  <Flex justify="center" align="center" w="100%" {...props}>
    <Loader />
  </Flex>
);
